import axios from 'axios';
import { CONFIG } from 'src/config-global';
import { STORAGE_KEY } from 'src/auth/context/jwt/constant';

const sensitiveKeyPattern = /(authorization|token|password|secret|cookie|email|phone|address)/i;

const sanitizeText = (value) =>
  String(value || '')
    .replace(/\bBearer\s+[^\s,;]+/gi, 'Bearer [REDACTED]')
    .replace(/([?&](?:token|password|secret|key)=)[^&\s]*/gi, '$1[REDACTED]');

const sanitizeMeta = (value, key = '') => {
  if (sensitiveKeyPattern.test(key)) return '[REDACTED]';
  if (typeof value === 'string') return sanitizeText(value);
  if (Array.isArray(value)) return value.map((item) => sanitizeMeta(item));
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([entryKey, entryValue]) => [
        entryKey,
        sanitizeMeta(entryValue, entryKey),
      ])
    );
  }
  return value;
};

const getAccessToken = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

const getBrowserInfo = () => {
  return navigator.userAgent || '';
};

const getOSInfo = () => {
  const userAgent = navigator.userAgent;

  if (/Windows/i.test(userAgent)) return 'Windows';
  if (/Mac/i.test(userAgent)) return 'MacOS';
  if (/Linux/i.test(userAgent)) return 'Linux';
  if (/Android/i.test(userAgent)) return 'Android';
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'iOS';

  return 'Unknown';
};

export const logError = async (
  { type = 'javascript_error', message = '', stack_trace = '', meta = {} },
  endpoint
) => {
  try {
    const baseUrl = process.env.REACT_APP_SERVER_URL;
    console.log('baseUrl', baseUrl);
    const accessToken = getAccessToken();

    await axios.post(
      `${baseUrl}${endpoint}`,
      {
        type,
        message: sanitizeText(message),
        stack_trace: sanitizeText(stack_trace),

        url: window.location.href,
        method: 'CLIENT',

        browser: getBrowserInfo(),
        os: getOSInfo(),

        meta: {
          ...sanitizeMeta(meta),

          screen_width: window.innerWidth,
          screen_height: window.innerHeight,
          timestamp: new Date().toISOString(),
        },
      },
      {
        headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
      }
    );
  } catch {
    console.error('Unable to send error log.');
  }
};
